import { render, staticRenderFns } from "./RegisterClientWin.vue?vue&type=template&id=5695f2ce&scoped=true&"
import script from "./RegisterClientWin.vue?vue&type=script&lang=js&"
export * from "./RegisterClientWin.vue?vue&type=script&lang=js&"
import style0 from "./RegisterClientWin.vue?vue&type=style&index=0&id=5695f2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5695f2ce",
  null
  
)

export default component.exports